import { render } from "./TransactionView.vue?vue&type=template&id=516803b9&scoped=true"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"

import "./TransactionView.vue?vue&type=style&index=0&id=516803b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516803b9"]])

export default __exports__